export enum BottomPanelPresetHeight {
  small = 'preset-height-small',
  big = 'preset-height-big',
}
